var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"v-layout1",staticStyle:{"padding-bottom":"100px","padding-top":"12px"},attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('head-member')],1),_c('v-col',{staticClass:"gametap px-4",attrs:{"cols":"12"}},[_c('external-game-tab')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }